import { render, staticRenderFns } from "./help-dropdown-menu.vue?vue&type=template&id=43db5f22&scoped=true&"
import script from "./help-dropdown-menu.vue?vue&type=script&lang=js&"
export * from "./help-dropdown-menu.vue?vue&type=script&lang=js&"
import style0 from "./help-dropdown-menu.vue?vue&type=style&index=0&id=43db5f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43db5f22",
  null
  
)

export default component.exports